import axios from ".";
import { getTrackingDataForPayload } from '../../utils/tracking-link';

export default {
  createSubscriptionPlan,
  getSubscriptionPlans,
  getSubscriptionPlansForUser,
  updateDefaultSubscriptionPrice,
  deleteSubscriptionPlan,
  subscribeToPlan,
  cancelSubscription,
  isSubscribedTo,
  setSubscriptionFree,
  getMyActiveSubscriptions,
  getActiveSubscribers,
};

async function createSubscriptionPlan(data) {
  const response = await axios.post("/api/subscription-plans/create", {
    months: Number(data.months),
    discount: Number(data.discount),
  });
  return response.data;
}

async function getSubscriptionPlans() {
  const response = await axios.get("/api/subscription-plans");
  return response.data;
}

async function updateDefaultSubscriptionPrice(amount) {
  const response = await axios.post("/api/subscription-plans/update-price", {
    amount,
  });
  return response.data;
}

async function deleteSubscriptionPlan(subscriptionPlanId) {
  const response = await axios.delete(
    "/api/subscription-plans/" + subscriptionPlanId
  );
  return response.data;
}

async function getSubscriptionPlansForUser(user_id) {
  const response = await axios.get(
    "/api/subscriptions/plans?performer_id=" + user_id
  );
  return response.data;
}

async function subscribeToPlan(subscriptionPlanId, postId = null) {
  const trackingData = getTrackingDataForPayload();
  const data = {
    ...(postId && { post_id: postId }),
    ...trackingData
  };
  const response = await axios.post(
    `/api/subscriptions/plans/${subscriptionPlanId}/subscribe`,
    data
  );
  return response.data;
}

async function cancelSubscription(subscriptionId) {
  const response = await axios.post(
    `/api/subscriptions/${subscriptionId}/cancel`
  );
  return response.data;
}

async function isSubscribedTo(performer_id) {
  const response = await axios.post(`/api/subscriptions/is-subscribed-to`, {
    performer_id,
  });
  return response.data;
}

async function setSubscriptionFree(subscription_plan_id) {
  const response = await axios.put(`/api/subscription-plans/set-free`, {
    subscription_plan_id,
  });
  return response.data;
}

async function getMyActiveSubscriptions(payload) {
  let url = '/api/subscriptions/my-subscriptions';
  if (payload) {
    if (payload.limit) url += `?limit=${payload.limit}`;
    if (payload.page) url += url.includes('?') ? `&page=${payload.page}` : `?page=${payload.page}`;
  }

  const response = await axios.get(url);
  return response.data;
}

async function getActiveSubscribers(payload) {
  let url = '/api/subscription-plans/subscribers';
  if (payload) {
    if (payload.limit) url += `?limit=${payload.limit}`;
    if (payload.page) url += url.includes('?') ? `&page=${payload.page}` : `?page=${payload.page}`;
  }

  const response = await axios.get(url);
  return response.data;
}
